import React from "react";

const sel = {
  padding: "7px 10px", borderRadius: 6, border: "1px solid #e2e8f0",
  fontSize: "0.85rem", color: "#0f172a", background: "#fff", boxSizing: "border-box",
};
const lbl = {
  display: "block", fontSize: "0.72rem", fontWeight: 700, color: "#475569",
  marginBottom: 4, textTransform: "uppercase", letterSpacing: "0.03em",
};

const HOURS   = Array.from({ length: 4 },  (_, i) => i);      // 0–3 hrs
const MINUTES = [0, 15, 30, 45];

export const computeEndTime = (startHHmm, durationHrs, durationMins) => {
  if (!startHHmm) return "";
  const [h, m] = startHHmm.split(":").map(Number);
  const total  = h * 60 + m + Number(durationHrs) * 60 + Number(durationMins);
  const eh     = Math.floor(total / 60) % 24;
  const em     = total % 60;
  return `${String(eh).padStart(2, "0")}:${String(em).padStart(2, "0")}`;
};

/**
 * Props:
 *   startTime   – "HH:mm"
 *   durationHrs – number (0–3)
 *   durationMins– number (0,15,30,45)
 *   endTime     – "HH:mm" (computed, shown read-only)
 *   onStartChange    – (HHmm) => void
 *   onDurationChange – (hrs, mins) => void
 *   inpStyle    – optional override for input/select style
 */
const DurationTimePicker = ({
  startTime, durationHrs, durationMins, endTime,
  onStartChange, onDurationChange, inpStyle = {},
}) => {
  const merged = { ...sel, ...inpStyle };

  const handleStart = (val) => onStartChange(val);

  const handleHrs  = (val) => onDurationChange(Number(val), durationMins);
  const handleMins = (val) => onDurationChange(durationHrs, Number(val));

  return (
    <div style={{ display: "grid", gridTemplateColumns: "1fr 80px 80px 1fr", gap: 10 }}>
      <div>
        <label style={lbl}>Start Time</label>
        <input type="time" style={merged} value={startTime}
          onChange={(e) => handleStart(e.target.value)} />
      </div>
      <div>
        <label style={lbl}>Hrs</label>
        <select style={merged} value={durationHrs} onChange={(e) => handleHrs(e.target.value)}>
          {HOURS.map((h) => <option key={h} value={h}>{h}h</option>)}
        </select>
      </div>
      <div>
        <label style={lbl}>Mins</label>
        <select style={merged} value={durationMins} onChange={(e) => handleMins(e.target.value)}>
          {MINUTES.map((m) => <option key={m} value={m}>{m}m</option>)}
        </select>
      </div>
      <div>
        <label style={lbl}>End Time</label>
        <input type="time" style={{ ...merged, background: "#f8fafc", color: "#64748b" }}
          value={endTime} readOnly />
      </div>
    </div>
  );
};

export default DurationTimePicker;
